import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { FaArrowCircleLeft } from "react-icons/fa";

export default function PageHeader({
  title,
  backPath = null,
  onBack = null,
  showBack = true,
  icon = null,
  className = "",
}) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof onBack === "function") return onBack();
    if (backPath) return navigate(backPath);
    return navigate(-1);
  };

  return (
    <div className={`flex items-center mb-2 justify-start gap-2 ${className}`}>
      {showBack && (
        <FaArrowCircleLeft
          className={`text-primary cursor-pointer ${i18n.dir () === "rtl" ? "rotate-180" :" "}`}
          size={20}
          onClick={handleBack}
        />
      )}
      {icon ? <span className="text-primary flex items-center">{icon}</span> : null}
      <h2 className="text-2xl font-semibold">{title}</h2>
    </div>
  );
}
